export default __webpack_public_path__ + "static/media/img-02.bc52940c.jpg";